// Typelizer digest 350ec3435bedeb4f233f5cf9e537d2ee
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
export type Method = 'get' | 'post' | 'put' | 'patch' | 'delete'

export type RouteDefinition<M extends Method> = {
  url: string
  method: M
}

export type RouteOptions = {
  query?: Record<string, unknown>
  anchor?: string
}

let baseUrl = ''
let urlDefaults: Record<string, unknown> | (() => Record<string, unknown>) = {}

export function setBaseUrl(url: string): void {
  baseUrl = url.replace(/\/+$/, '')
}

export function setUrlDefaults(defaults: Record<string, unknown> | (() => Record<string, unknown>)): void {
  urlDefaults = defaults
}

export function addUrlDefault(key: string, value: unknown): void {
  const current = typeof urlDefaults === 'function' ? urlDefaults : { ...urlDefaults }
  if (typeof current === 'function') {
    const fn = current
    urlDefaults = () => ({ ...fn(), [key]: value })
  } else {
    current[key] = value
    urlDefaults = current
  }
}

export function buildUrl(
  template: string,
  params: Record<string, unknown> | string | number,
  options?: RouteOptions,
): string {
  const defaults = typeof urlDefaults === 'function' ? urlDefaults() : urlDefaults
  let p: Record<string, unknown>

  if (typeof params === 'string' || typeof params === 'number') {
    const key = template.match(/[:*]\w+/g)?.map((name) => name.slice(1)).find((name) => getParam(defaults, name) == null)
    p = key ? { ...defaults, [key]: params } : { ...defaults }
  } else {
    p = { ...defaults, ...params }
  }

  // Optional segments: fill or remove
  let url = template.replace(/\(\/:?(\w+)\)/g, (_, key) => {
    const val = getParam(p, key)
    if (val != null) return `/${encodeURIComponent(String(val))}`
    return ''
  })

  // Glob params
  url = url.replace(/\*(\w+)/g, (match, key) => {
    const val = getParam(p, key)
    if (val == null) return match
    return Array.isArray(val) ? encodeURI(val.map(String).join('/')) : encodeURI(String(val))
  })

  // Required params
  url = url.replace(/:(\w+)/g, (match, key) => {
    const val = getParam(p, key)
    if (val != null) return encodeURIComponent(String(val))
    return match
  })

  // Query string
  if (options?.query) {
    const qs = buildQuery(options.query)
    if (qs) url += `?${qs}`
  }

  // Anchor
  if (options?.anchor) url += `#${options.anchor}`

  return baseUrl + url
}

// Accepts both snake_case and camelCase param keys by looking up
// the snake_case key from the URL template, then its camelCase equivalent.
function getParam(params: Record<string, unknown>, key: string): unknown {
  if (key in params) return params[key]
  return params[toCamelCase(key)]
}

function toCamelCase(key: string): string {
  return key.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase())
}

function buildQuery(params: Record<string, unknown>, prefix?: string): string {
  const parts: string[] = []
  for (const [key, value] of Object.entries(params)) {
    const k = prefix ? `${prefix}[${key}]` : key
    if (value === null || value === undefined) continue
    if (Array.isArray(value)) {
      value.forEach(v => parts.push(`${k}[]=${encodeURIComponent(String(v))}`))
    } else if (typeof value === 'object') {
      const nested = buildQuery(value as Record<string, unknown>, k)
      if (nested) parts.push(nested)
    } else {
      parts.push(`${k}=${encodeURIComponent(String(value))}`)
    }
  }
  return parts.join('&')
}
